import { ActionTypes } from '../constants/actionTypes.js';
import {api} from "../apis/ComponentApis.js";


// open and close filter drawer action creators
export const reportmodalOpenActions = (active) => ({
    type: ActionTypes.SET_REPORT_FILTER_DRAWER_OPEN,
    payload: active
   });
   
   export const setFiltersCreateReportFormData = (field, value) => ({
    type: ActionTypes.SET_FILTER_CREATE_REPORT_FORMDATA,
    payload: {field, value}
   });

   export const resetfilterFormData = () => ({
    type: ActionTypes.RESET_FILTER_CREATE_REPORT_FORMDATA,
   });

   export const fetchCreateReportSummaryRequest = () => ({
   type: ActionTypes.FETCH_CREATE_REPORT_SUMMARY_REQUEST,
   });

   export const getReportSummartData = (reportData) => ({
    type: ActionTypes.GET_REPORT_SUMMARY_DATA,
    payload: reportData
    });
    
const fetchReportData = (origin, signal) => async(dispatch) => {
    dispatch(fetchCreateReportSummaryRequest());
    try{
        const reportList = await api.get(`/api/GetReportData`, {signal});
        dispatch(getReportSummartData(reportList.data));
        if(origin !== "default") {
            alert("Reports Created Successfully!");
            dispatch({
                type: ActionTypes.DISABLE_LOADING
        });
        dispatch({
            type: ActionTypes.SET_SELECTED_DATERANGE,
            payload: {startDate : null, endDate : null}
    });
        }
    } catch (error){
        if(error.name === 'canceled') {
            console.log('Request canceled', error);
            return;
        }
        dispatch({
            type: ActionTypes.DISABLE_LOADING,
            payload: error
        })
    }
}

 export const getDefaultReportSummaryData = (signal) => async (dispatch) => {
    dispatch(fetchReportData("default", signal));
 }

   export const fetchCreateRequestSummaryData = (requestParams) => async (dispatch) => {
    dispatch(fetchCreateReportSummaryRequest());
    try {
        const response = await api.post(`/api/AddReport`, requestParams);
        if(response.data.code === 201) {
          dispatch(fetchReportData("createrequest"));
        } else if(response.data.code === 5021) {
            alert("Report is already available for the selected date range");
            dispatch({
                type: ActionTypes.DISABLE_LOADING,
        });
        }
    } catch (error) {
        dispatch({
            type: ActionTypes.FETCH_CREATE_REPORT_SUMMARY_FAILURE,
            payload: error
        })
    }
};

export const fetchSiteList = (signal) => async (dispatch) => {
    try {
        const response = await api.get(`/api/GetSiteList`, { signal });
        if(response) {
          dispatch({type: ActionTypes.SET_SITELIST, payload: response.data});
        }
    } catch (error) {
        if (error.name === 'canceled') {
            console.log('Request canceled', error);
            return;
        } else {
 console.log("Error Fetching Sites" + error);
        }  
    }
};

export const setReportDetailsParameters = (parameters) => ({
    type: ActionTypes.SET_REPORT_DETAILS_PARAMETERS,
    payload: parameters
    });

    export const resetReportParameters = () => ({
        type: ActionTypes.RESET_REPORT_PARAMETERS,
        });
